export const API_HOST = 'https://api.nuserenitywellness.com'
